import { render, staticRenderFns } from "./BagEans.vue?vue&type=template&id=5f852dc8"
import script from "./BagEans.vue?vue&type=script&lang=js"
export * from "./BagEans.vue?vue&type=script&lang=js"
import style0 from "./BagEans.vue?vue&type=style&index=0&id=5f852dc8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports